import useMeetingOrigin from '@/meeting/hooks/useMeetingOrigin'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CirclePerimeter, SearchPerimeterProps } from '../circlePerimeter'
import CirclePerimeterBar from '../components/CirclePerimeterBar'
import useCirclePerimeter from './useCirclePerimeter'

// The perimeter wiring shared by the two circle pickers (input and button):
// the filter state and the bar that shows it at the top of the list (#123).
// Opened from a meeting, the filters are the meeting's circle and the org.
export default function useCirclePerimeterFilter(
  defaultPerimeter: CirclePerimeter
): SearchPerimeterProps {
  const { t } = useTranslation()
  const meetingOrigin = useMeetingOrigin()
  const { offered, perimeter, setPerimeter, isInPerimeter, isPartitioned } =
    useCirclePerimeter(defaultPerimeter, meetingOrigin?.circleIds)

  return {
    header: (
      <CirclePerimeterBar
        offered={offered}
        value={perimeter}
        meetingCircleName={meetingOrigin?.circleName}
        onChange={setPerimeter}
      />
    ),
    isInPerimeter,
    isPartitioned,
    separatorLabel: t('CirclePerimeter.elsewhereInOrg'),
  }
}
